import React from 'react';
import StationChooser from "../stations/StationChooser";
import {Edit, SaveButton, SelectInput, SimpleForm, Toolbar} from "react-admin";
import BaseAdHocPage from "../../framework/util/uicomps/BaseAdHocPage";
import PressPalletIcon from "../presspalletbuilder/PressPalletIcon";
import Grid from "@material-ui/core/Grid";

const Title = ({record}) => {
    return <span>Station Association</span>;
};

const CustomToolbar = props => (
    <Toolbar handleSubmitWithRedirect={props.handleSubmitWithRedirect}>
        <SaveButton
            redirect="/"
            fullWidth
            submitOnEnter={true}
        />
    </Toolbar>
);

const form = (props) => (<Edit title={<Title/>} component="div" {...props}>
    <SimpleForm toolbar={<CustomToolbar {...props}/>}>
        <StationChooser fullWidth={true}/>
    </SimpleForm>
</Edit>);

const title = 'Station Identity';
const description = 'Associate this physical station with a station configured in the system.  Functionality is enabled depending on the type of station.  This is typically done once, at initial station setup.';

const Page = (props)=>(<BaseAdHocPage icon={<PressPalletIcon/>} title={title}
                             description={description} buttons={[]}
                             content={[form({...props})]}/>
);
const PageInGrid = (props)=> (

    <Grid container
          direction="row"
          justify="center"
          alignItems="center"
    >
        <Grid item xs={3}>
        </Grid>
        <Grid item xs={6}>
            <Page   {...props}/>
        </Grid>
        <Grid item xs={3}>
        </Grid>
    </Grid>

);

const StationAdoptEdit = ({record, ...props}) => {

    return (
        (<PageInGrid  {...props}/>)
    );

}

export default StationAdoptEdit;
